import { Box } from '@mui/material'

/**
 * Responsive filter row: 1 col mobile, 2 col tablet, 3 on medium, 8 on large.
 * Child controls may use `gridColumn: { lg: 'span N' }`; keep the total span ≤ 8 per row.
 */
export function FilterGrid({ children, sx }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          lg: 'repeat(8, minmax(0, 1fr))',
        },
        gap: 1.5,
        alignItems: 'center',
        mb: 2,
        '& > *': { minWidth: 0 },
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}
